import React from "react";

interface ChevronDownProps {
  style?: React.CSSProperties;
  className?: string;           
  rotation?: string;             
}

function ChevronDown({ style, className, rotation }: ChevronDownProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32"
      fill="currentColor"
      className={className}                      
      style={{ ...style, transform: rotation }}  
    >
      <path 
        d="M15.754 18.212l8.879-8.879 2.034 2.034L15.754 22.28 4.841 11.367l2.034-2.034 8.879 8.879z"
      />
    </svg>
  );
}

export default ChevronDown;
